import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import get from 'lodash/get';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import cn from 'classnames';
import Heading from '../Heading';
import ReportLoader from '../ReportLoader';

import deliveryTruck from '../img/deliveryTruck.svg';

import { Table, TR } from '../../FullVinReportStyles';

// TODO исправить интерфейс
interface IMappedTechData {
  [key: string]: { title: string; description?: any };
}

const TechData: FC = observer(() => {
  const {
    checksStore: {
      techData: { data, invalid_fields },
    },
  } = useStores();

  const mappedTechData: IMappedTechData = {
    brand_and_model: {
      title: 'Марка и модель',
      description: get(data, 'brand_and_model'),
    },
    vin: {
      title: 'Vin',
      description: get(data, 'vin'),
    },
    type: {
      title: 'Тип кузова',
      description: get(data, 'type'),
    },
    color: {
      title: 'Цвет',
      description: get(data, 'color'),
    },
    year: {
      title: 'Год выпуска',
      description: get(data, 'year'),
    },
    engine_type: {
      title: 'Тип двигателя',
      description: get(data, 'engine_type'),
    },
    engine_volume: {
      title: 'Объем двигателя',
      description: has(data, 'engine_volume') && `${get(data, 'engine_volume')} л`,
    },
    engine_power: {
      title: 'Мощность двигателя',
      description: has(data, 'engine_power') && `${get(data, 'engine_power')} л.с.`,
    },
    netto_weight: {
      title: 'Масса без нагрузки',
      description: has(data, 'netto_weight') && `${get(data, 'netto_weight')} кг`,
    },
    max_weight: {
      title: 'Разрешенная макс. масса',
      description: has(data, 'max_weight') && `${get(data, 'max_weight')} кг`,
    },
    capacity: {
      title: 'Грузоподъемность',
      description: has(data, 'capacity') && `${get(data, 'capacity')} т`,
    },
    drive_type: {
      title: 'Тип привода',
      description: get(data, 'drive_type'),
    },
    wheel_position: {
      title: 'Расположение руля',
      description: get(data, 'wheel_position'),
    },
  };

  const renderHeadingDescription = () => {
    if (isEmpty(data)) return 'Общие сведения';

    if (!isEmpty(data) && isEmpty(invalid_fields)) {
      return 'Сведения из ПТС';
    }

    return 'Есть расхождения с объявлением';
  };

  const renderReport = (report: IMappedTechData, invalidFields?: string[]) => {
    return Object.keys(report).map((item, index) => {
      const isInvalid: boolean | undefined = invalidFields?.includes(item);
      const { title, description } = report[item];

      if (!description) return null;

      return (
        <TR key={index}>
          <td className={cn(isInvalid && 'is-invalid-opacity', 'gray')}>{title}</td>
          <td className={cn(isInvalid && 'is-invalid')}>{description}</td>
        </TR>
      );
    });
  };

  return (
    <section className="section-box">
      <Heading
        icon={<img src={deliveryTruck} alt="icon-delivery-truck" />}
        descr={renderHeadingDescription()}
        beCarefulState={!isEmpty(data) && !isEmpty(invalid_fields)}
      />
      {!isEmpty(data) ? (
        <Table>
          <tbody>{renderReport(mappedTechData, invalid_fields)}</tbody>
        </Table>
      ) : (
        <ReportLoader />
      )}
    </section>
  );
});

export default TechData;
